// @flow
export const updateLocal = (name: string, data: any) => {
  localStorage.setItem(
    name,
    JSON.stringify({
      content: JSON.stringify(data),
      timestamp: new Date().getTime()
    })
  );
};
